<template>
  <div style="background: #f7f8fa" class="opera-order">
    <topNav :title="$t('operaOrder_title')" url="/opera/fangT" replace="true"></topNav>
    <div class="room">
      <span>{{$route.query.rmno}}{{$t('operaOrder_room')}}</span>
    </div>
    <div class="content">
      <div class="form ">
        <div class="info">
          <label>{{$t('fangTXQ_rmtype')}}</label> <input type="text" disabled v-model="bookInfo.rmtype" readonly="readonly">
        </div>
        <div class="info">
          <label>{{$t('name')}}</label> <input type="text" :placeholder="$t('operaOrder_bookinfo_name')" v-model='bookInfo.name'>
        </div>
        <div class="info">
          <label>{{$t('mobile')}}</label> <input type="text" placeholder="$t('operaOrder_bookinfo_mobile')" v-model='bookInfo.mobile'>
        </div>
        <div class="info">
          <label>{{$t('book_idCode')}}</label>
          <div class="parent" :class="{focus:selectedInput=='idCode'}">
            <input type="text" name="" v-model='inputVal.idCode' readonly="readonly" @touchstart="showPop('idCode')">
            <i class="iconfont icon-xia"></i>
          </div>
        </div>
        <div class="info">
          <label>{{$t('book_idNo')}}</label> <input type="text" :placeholder="$t('book_idNo_placeholder_required')" v-model='bookInfo.idNo'>
        </div>
        <div class="info">
          <label>{{$t('operaOrder_live_in_date')}}</label>
          <div class="parent">
            <div @click="openPick('picker')">{{startTime.time | fdate}}</div>
            <mt-datetime-picker ref="picker" type="date" @confirm="handleConfirm" :startDate="minDate"
                                :endDate="maxDate" v-model="startTime.time"></mt-datetime-picker>
          </div>
        </div>
        <div class="info">
          <label>{{$t('delayIn_EndDate')}}</label>
          <div class="parent">
            <div @click="openPick('picker2')">{{endTime.time | fdate}}</div>
            <mt-datetime-picker ref="picker2" type="date" :startDate="minDate2" :endDate="maxDate"
                                v-model="endTime.time"></mt-datetime-picker>
          </div>
        </div>
        <div class="info">
          <label>{{$t('book_salesman')}}</label>
          <div class="parent" :class="{focus:selectedInput=='salesMan'}">
            <input type="text" name="" v-model='inputVal.salesMan' @touchstart="showPop('salesMan')"
                   readonly="readonly">
            <i class="iconfont icon-xia"></i>
          </div>
        </div>
        <div class="info">
          <label>{{$t('remark')}}</label>
          <textarea class="remark" v-model='bookInfo.remark'></textarea>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="bookbtn" @click='book' v-if="rights.indexOf('resrv!fit!add') >= 0">{{$t('fangT_reserveBook')}}</div>
      <div class="bookbtn" @click='checkIn' v-if="rights.indexOf('recept!fit!ci') >= 0">{{$t('fangT_walkBook')}}</div>
    </div>
    <!-- input弹框 -->
    <mt-popup class="pop" v-model="popupVisible" position="bottom" :modal="false" :closeOnClickModal='false'>
      <div class="roomNums">
        <div class="top">
          <mt-button class="sure" @click='changeValue'>{{$t('determine')}}</mt-button>
          <div class="cancel" @touchstart="popupVisible=false;selectedInput=''">
            <i class="iconfont icon-cuowu"></i>
          </div>
        </div>
      </div>
      <div class="warp">
        <div class="rollWarp" id='slideBlock'>
          <mt-picker :slots="optionSlot" @change='slideChange' :visible-item-count="5" :itemHeight="40"></mt-picker>
        </div>
      </div>
    </mt-popup>

  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import moment from 'moment'

  export default {
    data() {
      return {
        /*日历信息*/
        startTime: {
          time: this.$route.query.date || moment().format("YYYY-MM-DD")
        },
        endTime: {
          time: this.$route.query.enddate || moment().add('d', 1).format("YYYY-MM-DD")
        },
        minDate: moment(moment().format("YYYY-MM-DD")).toDate(),
        minDate2: moment(moment().add('d', 1).format("YYYY-MM-DD")).toDate(),
        maxDate: moment(moment().add(6, "M").format("YYYY-MM-DD")).toDate(),

        rights: [],
        popupVisible: false,

        optionSlot: [],
        options: { //bottomPop配置项
          idCode: [{
            flex: 1,
            defaultIndex: 1,
            values: [],
            code: [],
          }],
          salesMan: [{
            flex: 1,
            defaultIndex: 1,
            values: [],
            code: []
          }]
        },
        inputVal: {idCode: this.$t('operaOrder_bookinfo_id'), salesMan: ''},//输入框要显示的值
        selectedInput: '',//弹框的数值对象
        selectedvalue: '',//备选的值
        selectedcode: '',//备选的code
        bookInfo: {
          arr: '',//入住时间（非空）
          dep: '',//离店时间（非空）
          idCode: '01',//	证件类型（可空）  -----默认身份证
          idNo: '',//	证件号（可空）
          mobile: '',//	手机，散客会员时填写，协议公司可空
          name: '',//	预订人不可空
          remark: '',//备注（可空）
          rmno: this.$route.query.rmno,
          rmtype: this.$route.query.rmtype,//	房型不可空
          salesman: '',//	销售员，可空
        },
      }
    },
    mounted() {
      // console.log(moment('2016-05-2').isBefore('2016-05-16'));
      /*获取房间详情*/
      this.$http.get('/mobilepmsapi/sys/rights/walkin').then(res => {
        if (res.data.result == 0) {
          this.rights = res.data.retVal;
        }
      });
      /*获得PMS下拉参数--证件类型*/
      this.$http.get('/mobilepmsapi/sys/pmsPrarms?', {params: {type: 'ID_CODES'}}).then(res => {
        res.data.retVal.forEach((val, key, arr) => {
          this.options.idCode[0].values.push(arr[key].name);
          this.options.idCode[0].code.push(arr[key].code);
        })
      });
      /*获得PMS下拉参数--销售员*/
      this.$http.get('/mobilepmsapi/sys/pmsPrarms?', {params: {type: 'SALES_MAN'}}).then(res => {
        res.data.retVal.forEach((val, key, arr) => {
          this.options.salesMan[0].values.push(arr[key].name);
          this.options.salesMan[0].code.push(arr[key].code);
        })
      });
    },
    methods: {
      showPop(item) {
        this.optionSlot = this.options[item];
        this.popupVisible = true;
        this.selectedInput = item;
      },
      slideChange(picker, values) {
        this.dataIndex = picker.$children[0].valueIndex;//所选数据在数组中的序号
        this.selectedvalue = values[0];//所选数据
        this.selectedcode = this.options[this.selectedInput][0].code[this.dataIndex];//所选code
      },
      //确定按钮
      changeValue() {
        this.inputVal[this.selectedInput] = this.selectedvalue;
        this.bookInfo[this.selectedInput] = this.selectedcode;
        this.popupVisible = false;
        this.selectedInput = '';
      },
      openPick(p) {
        this.$refs[p].open();
      },
      handleConfirm(d) {
        this.minDate2 = moment(this.startTime.time).add('d', 1).toDate();
        if (moment(this.endTime.time) < moment(this.startTime.time)) {
          this.endTime.time = moment(this.startTime.time).add('d', 1).format("YYYY-MM-DD");
        }
      },

      /*步入预订*/
      book() {
        this.bookInfo.arr = moment(this.startTime.time).format("YYYY-MM-DD");
        this.bookInfo.dep = moment(this.endTime.time).format("YYYY-MM-DD");

        if (!this.checkData()) {
          return false;
        }
        console.log(this.bookInfo)
        this.$http.post(' /mobilepmsapi/reception/reserve', this.bookInfo).then(res => {
          if (res.data.result == 0) {
            this.$router.push('/opera/fangTXQ?id=' + res.data.retVal.id);
          } else {
            this.msg(res.data.msg);
          }
          // console.log(res.data)
        })
      },
      msg(msg) {
        Toast({
          message: msg,
          position: 'bottom',
          duration: 3000
        });
      },
      checkData() {
        if (this.bookInfo.name == "") {
          this.msg(this.$t('msg_rsvMan'));
          return false;
        }
        if (this.bookInfo.mobile == "") {
          this.msg(this.$t('msg_isEmpty_mobile'));
          return false;
        }
        return true;
      },
      /*散客吧步入*/
      checkIn() {
        this.bookInfo.arr = moment(this.startTime.time).format("YYYY-MM-DD");
        this.bookInfo.dep = moment(this.endTime.time).format("YYYY-MM-DD");
        if (!this.checkData()) {
          return false;
        }
        this.$http.post('/mobilepmsapi/reception/walkIn', this.bookInfo).then(res => {
          if (res.data.result == 0) {
            this.$router.push('/opera/fangTXQ?id=' + res.data.retVal.id);
          } else {
            this.msg(res.data.msg);
          }
        })
      },

    },
    filters: {
      fdate(value) {
        return moment(value).format("YYYY-MM-DD");
      }
    },
    components: {}
  }
</script>
<style lang="less">
  .opera-order {
    .datepickbox {
      input {
        text-align: left !important;
        font-size: 0.32rem !important;
      }
    }

    .room {
      background-color: #fff;
      padding: 0 20px;
      height: 35px;
      margin-bottom: 5px;

      span {
        display: inline-block;
        line-height: 30px;
        border-bottom: 2px solid #F69C2D;
      }
    }

    .content {
      background-color: #FFF;

      .form {
        padding: 5px 0.26666667rem;
        overflow: hidden;

        .info {
          box-sizing: border-box;
          margin: 0.12rem auto;
          overflow: hidden;
          line-height: 0.88rem;
          float: left;

          label {
            box-sizing: border-box;
            padding-left: 0.13333333rem;
            float: left;
            text-align: left;
            width: 2.33333333rem;
            font-size: 0.32rem;
          }

          input {
            float: right;
            width: 6.86666667rem;
            height: 0.88rem;
            border: 1px solid #e8e8e8;
            margin: 0 0.13333333rem;
            padding: 0 0.13333333rem;
            box-sizing: border-box;
            outline: 0;
          }

          .parent {
            position: relative;
            margin: 0 0.13333333rem;
            padding: 0 0.13333333rem;
            float: right;
            width: 6.86666667rem;
            box-sizing: border-box;
            height: 0.88rem;
            border: 1px solid #e8e8e8;

            &.focus {
              border: 1px solid #e0b47b;

              .iconfont {
                color: #e0b47b;
              }
            }

            input {
              border: none;
              width: 85%;
              float: left;
              height: 0.82666667rem;
              box-sizing: border-box;
            }

            .iconfont {
              position: absolute;
              right: 0.26666667rem;
              top: 0px;
              /* transform: rotate(-90deg);*/
            }
          }

          .remark {
            width: 6.86666667rem;
            height: 1.6rem;
            border: 1px solid #e8e8e8;
            outline: none;
            box-sizing: border-box;
            display: block;
            float: right;
            padding: 0;
            margin-left: 0.13333333rem;
          }
        }
      }
    }

    .foot {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1.2rem;
      background-image: -webkit-linear-gradient(to left, #ff6e61, #f6a12a);
      background-image: -o-linear-gradient(to left, #ff6e61, #f6a12a);
      background-image: linear-gradient(to left, #ff6e61, #f6a12a);
      font-size: 0.42666667rem;
      color: #fff;
      text-align: center;
      z-index: 1000;

      .amount {
        line-height: 1.2rem;
        height: 1.2rem;
        float: left;
        width: 50%;
        box-sizing: border-box;

        .iconfont {
          margin-left: 0.08rem;
          /*-webkit-transform: translateY(-0.05333333rem) rotate(90deg);
  -moz-transform: translateY(-0.05333333rem) rotate(90deg);
  -ms-transform: translateY(-0.05333333rem) rotate(90deg);
  -o-transform: translateY(-0.05333333rem) rotate(90deg);
  transform: translateY(-0.05333333rem) rotate(90deg);*/
          display: inline-block;
          font-size: 0.26666667rem;
        }
      }

      .bookbtn {
        line-height: 1.2rem;
        height: 1.2rem;
        box-sizing: border-box;
        width: 50%;
        float: left;
        /*&:nth-of-type(1){
      border-right: 1px solid #fff;
    }*/
      }
    }

    .pop {
      width: 10rem;
      box-shadow: 0px -0.06666667rem 0.13333333rem 0.06666667rem #e8e8e8;

      .roomNums {
        .top {
          box-sizing: border-box;
          width: 10rem;
          height: 1.2rem;
          padding: 0.21333333rem 0.4rem 0.16rem;
          border-bottom: 1px solid #DDD;

          .sure {
            margin-left: 0.02666667rem;
            float: left;
            height: 0.85333333rem;
            width: 1.86666667rem;
            border-radius: 0.10666667rem;
            font-size: 0.37333333rem;
            color: #333;
            background: #f4f4f4;
            border: 1px solid #ddd;
          }

          .cancel {
            float: right;
            width: 0.85333333rem;
            height: 0.85333333rem;
            text-align: center;

            .iconfont {
              color: #333;
              line-height: 0.85333333rem;
              font-size: 0.37333333rem;
            }
          }
        }
      }

      .warp {
        height: 5.33333333rem;
        overflow: hidden;

        .rollWarp {
          box-sizing: border-box;
          height: 5.33333333rem;
          overflow: auto;

          .picker {
            .picker-slot {
              font-size: 0.4rem;

              .picker-item {
                &.picker-selected {
                  font-size: 0.64rem;
                }
              }
            }

            .picker-center-highlight {
              background: rgba(200, 200, 200, 0.3);
            }
          }
        }
      }
    }

    .mx_pop {
      background: transparent;
      z-index: 100 !important;

      .mx {
        box-shadow: 0px -0.08rem 0.4rem 0.10666667rem #e8e8e8;
        width: 10rem;
        box-sizing: border-box;
        padding: 0 0.4rem;
        margin-bottom: 1.2rem;
        background: #fff;

        .count {
          height: 1.22666667rem;
          border-bottom: 1px solid #e8e8e8;

          span {
            font-size: 0.4rem;
            float: left;
            line-height: 1.22666667rem;
          }

          .icon {
            float: right;

            .iconfont {
              line-height: 1.22666667rem;
              font-size: 0.37333333rem;
            }
          }
        }

        .mxList {
          padding-top: 0.46666667rem;
          padding-bottom: 1.53333333rem;

          li {
            height: 0.74666667rem;

            span {
              width: 33.3%;
              height: 0.74666667rem;
              line-height: 0.74666667rem;
              font-size: 0.33333333rem;
              padding-left: 0.2rem;
              box-sizing: border-box;
              float: left;
              text-align: left;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// order.vue?2b30d63a